import { createContext } from "react";

import type useItemComponentIdentityById from "src/hooks/data/load/useItemComponentIdentityById";

/**
 * Describes the item component identity loader state and its refresh/cache actions.
 */
export interface IItemComponentIdentityContext extends ReturnType<
    typeof useItemComponentIdentityById
> {}

/**
 * Shares item component identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export default createContext<IItemComponentIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});
